import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import React from 'react';
import {
  FormControl,
  FormControlProps,
  FormGroup,
  Form,
} from 'react-bootstrap';
import { formatSSN } from '../../utils/utils';

export type TextInputProps = FormControlProps & {
  label?: string;
  placeholder?: string;
  icon?: IconProp;
  onBlur?: React.FocusEventHandler;
};
const placeholder = '___-__-____';

const SSNInput: React.FC<TextInputProps> = ({
  label,
  type = 'phone',
  icon = light('shield'),
  disabled,
  value,
  defaultValue,
  onChange,
  onBlur,
  isValid,
  isInvalid,
  className,
  ...props
}) => {
  const setIcon = (iconName: IconProp, side: string) => (
    <FontAwesomeIcon icon={iconName} className={`icon ${side}`} />
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.currentTarget;
    const formattedValue = formatSSN(inputValue.value);

    inputValue.value = formattedValue;
    onChange && onChange(e);
  }

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    onBlur && onBlur(e);
  }

  return (
    <FormGroup className={`${className ? className : ''} text-input-custom`}>
      {label && <Form.Label>{label}</Form.Label>}
      <div className="input-wrapper">
        {icon && setIcon(icon, 'icon--right')}
        <FormControl
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onBlur={handleBlur}
          isValid={isValid}
          isInvalid={isInvalid}
          disabled={disabled}
          defaultValue={defaultValue}
          {...props}
        />
      </div>
    </FormGroup>
  );
};

export default SSNInput;
